import React from 'react'

import { homePath } from '@/utils/index'
import { IBreadcrumb } from '@/types'
import { useApp } from '@/hooks'
import UserCan from './UserCan'
import Breadcrumbs from './Breadcrumbs'
import FormDeleteButton from './FormDeleteButton'
import FormEditButton from './FormEditButton'
import FormExtraButton from './FormExtraButton'

interface Props {
  objectName?: string
  breadcrumbs?: IBreadcrumb[]
  loading?: boolean
  isEditing?: boolean
  onEdit: () => void
  onDelete?: () => void
  extraButtons?: {
    text: string
    className?: string
    onClick: () => void
  }[]
  children: React.ReactNode
}

const FormWrapper: React.FC<Props> = ({
  breadcrumbs,
  isEditing,
  loading,
  onEdit,
  onDelete,
  extraButtons = [],
  children,
  objectName,
}) => {
  const { me } = useApp()

  const _breadcrumbs: IBreadcrumb[] = [
    {
      name: 'search',
      path: homePath,
    },
    ...(breadcrumbs || []),
  ]

  return (
    <div className="page-container">
      <div className="container">
        <div className="page-content">
          <Breadcrumbs
            breadcrumbs={_breadcrumbs}
            // rightContent={
            //   <div className="form-action-btns">
            //     <UserCan can={onDelete && !me?.isReadOnly}>
            //       <FormDeleteButton
            //         objectName={objectName}
            //         disabled={loading}
            //         onClick={onDelete}
            //       />
            //     </UserCan>
            //     {!isEditing && (
            //       <>
            //         <UserCan can={!me?.isReadOnly}>
            //           <FormEditButton disabled={loading} onClick={onEdit} />
            //         </UserCan>
            //         {extraButtons.map(({ text, className, onClick }, index) => (
            //           <FormExtraButton
            //             key={index}
            //             disabled={loading}
            //             className={className}
            //             text={text}
            //             onClick={onClick}
            //           />
            //         ))}
            //       </>
            //     )}
            //   </div>
            // }
          />
          <div className="form-action-btns">
            <UserCan can={onDelete && !me?.isReadOnly}>
              <FormDeleteButton
                objectName={objectName}
                disabled={loading}
                onClick={onDelete}
              />
            </UserCan>
            {!isEditing && (
              <>
                <UserCan can={!me?.isReadOnly}>
                  <FormEditButton disabled={loading} onClick={onEdit} />
                </UserCan>
                {extraButtons.map(({ text, className, onClick }, index) => (
                  <FormExtraButton
                    key={index}
                    disabled={loading}
                    className={className}
                    text={text}
                    onClick={onClick}
                  />
                ))}
              </>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default FormWrapper
